export enum AvailableEvents {
    "displayPopUp",
    "displayObject",
    "displayUsePanel",
    "beginQrScan",
    "endQrScan",
    "endOfGame"
}